'use client'

import {Label, Text} from '@/components/ui/Typography'
import {ChevronDownIcon} from 'lucide-react'
import {useState} from 'react'

export const FaqItem = ({question, answer}: {question: string; answer: string}) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className="bg-white rounded-2xl shadow-md border border-[#e7edee]  ">
      <button onClick={toggle} className="flex items-center gap-4 p-6 pb-4 justify-between w-full cursor-pointer">
        <Label className="text-xl md:text-2xl text-[#001923] text-left flex-1 min-w-0">{question}</Label>
        <ChevronDownIcon className="size-5 shrink-0" />
      </button>
      {isOpen && <Text className="text-[#001923] leading-relaxed whitespace-pre-line border-t p-6">{answer}</Text>}
    </div>
  )
}
